/**
 * Peachy · méga-menu des gammes.
 * Ouvre le panneau au survol ou au focus de l'entrée du menu principal dont le lien
 * correspond au déclencheur de la section, le place sous l'en-tête, le ferme au départ
 * du pointeur, à Échap ou au clic sur le voile.
 */
if (!customElements.get('pch-mega')) {
  customElements.define(
    'pch-mega',
    class PchMega extends HTMLElement {
      connectedCallback() {
        this.panel = this.querySelector('[data-mega-panel]');
        this.overlay = this.querySelector('[data-mega-overlay]');
        this.controller = new AbortController();
        this.closeTimer = null;
        const triggerPath = this.normalize(this.dataset.trigger);
        if (!this.panel || !triggerPath) return;

        const header = document.querySelector('#header-component');
        if (!header) return;
        this.header = header;
        this.triggers = [...header.querySelectorAll('a[href]')].filter((a) => this.normalize(a.getAttribute('href')) === triggerPath);
        const { signal } = this.controller;

        this.triggers.forEach((a) => {
          a.setAttribute('aria-haspopup', 'true');
          a.setAttribute('aria-expanded', 'false');
          a.addEventListener('pointerenter', () => this.open(), { signal });
          a.addEventListener('focus', () => this.open(), { signal });
          a.addEventListener('pointerleave', (e) => { if (!this.panel.contains(e.relatedTarget)) this.scheduleClose(); }, { signal });
        });
        this.panel.addEventListener('pointerenter', () => this.cancelClose(), { signal });
        this.panel.addEventListener('pointerleave', (e) => { if (!this.triggers.includes(e.relatedTarget?.closest?.('a'))) this.scheduleClose(); }, { signal });
        this.panel.addEventListener('focusout', (e) => { if (!this.panel.contains(e.relatedTarget) && !this.triggers.includes(e.relatedTarget)) this.close(); }, { signal });
        this.overlay?.addEventListener('click', () => this.close(), { signal });
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.classList.contains('is-open')) { this.close(); this.triggers[0]?.focus(); } }, { signal });
        window.addEventListener('scroll', () => { if (this.classList.contains('is-open')) this.place(); }, { signal, passive: true });
      }

      disconnectedCallback() {
        this.controller?.abort();
        clearTimeout(this.closeTimer);
      }

      normalize(href) {
        if (!href) return '';
        try {
          const path = new URL(href.replace(/^shopify:\/\/collections\//, '/collections/').replace(/^shopify:\/\/pages\//, '/pages/'), window.location.origin).pathname;
          return path.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/)/i, '').replace(/\/$/, '');
        } catch (e) {
          return '';
        }
      }

      place() {
        const bottom = this.header.getBoundingClientRect().bottom;
        this.style.setProperty('--pch-mega-top', `${Math.max(0, bottom)}px`);
      }

      open() {
        if (window.matchMedia('(max-width: 989px)').matches) return;
        this.cancelClose();
        if (this.classList.contains('is-open')) return;
        this.place();
        this.panel.hidden = false;
        this.classList.add('is-open');
        this.triggers.forEach((a) => a.setAttribute('aria-expanded', 'true'));
      }

      scheduleClose() {
        this.cancelClose();
        this.closeTimer = setTimeout(() => this.close(), 160);
      }

      cancelClose() {
        clearTimeout(this.closeTimer);
      }

      close() {
        this.cancelClose();
        this.panel.hidden = true;
        this.classList.remove('is-open');
        this.triggers.forEach((a) => a.setAttribute('aria-expanded', 'false'));
      }
    }
  );
}
